// extracted by mini-css-extract-plugin
export default {"wrap":"VideoPlay_wrap__-qpJe","video":"VideoPlay_video__TBf-S"};